/* @flow */

import Events from 'minivents';

window.BitsOfLove.eventManager = new Events();



// WEBPACK FOOTER //
// ./resources/assets/admin/global/js/eventmanager.js